import isServer from './isServer';
import getCookies from './getCookies';
import getEnvironmentName from './getEnvironmentName';

const getStoreDetails = () => {
  if (isServer()) {
    return null;
  }

  const environmentName = getEnvironmentName();

  // Only allow cookie override in non-production environments
  const rawHostName =
    (environmentName !== 'prod' && getCookies().get('storeHostName')) ||
    window.location.hostname;

  // Normalize *.store.joybird.com → *.joybird.com so both old and new subdomain
  // formats are recognized during the migration to *.store.joybird.com
  const storeHostName = rawHostName.replace(
    /^([^.]+)\.store\.joybird\.com$/,
    '$1.joybird.com'
  );

  switch (storeHostName) {
    case 'bk.joybird.com':
      return {
        id: '1',
        name: 'Brooklyn',
        zipCode: '11201',
      };
    case 'dc.joybird.com':
      return {
        id: '2',
        name: 'Washington',
        zipCode: '20005',
      };
    case 'chi.joybird.com':
      return {
        id: '4',
        name: 'Chicago',
        zipCode: '60610',
      };
    case 'weho.joybird.com':
      return {
        id: '6',
        name: 'West Hollywood',
        zipCode: '90069',
      };
    case 'sf.joybird.com':
      return {
        id: '7',
        name: 'San Francisco',
        zipCode: '94102',
      };
    case 'atx.joybird.com':
      return {
        id: '8',
        name: 'Austin',
        zipCode: '78758',
      };
    case 'sea.joybird.com':
      return {
        id: '9',
        name: 'Seattle',
        zipCode: '98122',
      };
    case 'soho.joybird.com':
      return {
        id: '10',
        name: 'Manhattan',
        zipCode: '10012',
      };
    case 'phil.joybird.com':
      return {
        id: '11',
        name: 'Philadelphia',
        zipCode: '19102',
      };
    case 'la.joybird.com':
      return {
        id: '12',
        name: 'Downtown Los Angeles',
        zipCode: '90021',
      };
    case 'den.joybird.com':
      return {
        id: '13',
        name: 'Denver',
        zipCode: '80206',
      };
    case 'vs.joybird.com':
      return {
        id: '5',
        name: 'Virtual Showroom',
        zipCode: '*',
      };
    case 'pdx.joybird.com':
      return {
        id: '14',
        name: 'Portland',
        zipCode: '97209',
      };
    case 'cs.joybird.com':
      return {
        id: '15',
        name: 'Customer Service',
        zipCode: '0',
      };
    case 'nis.joybird.com':
      return {
        id: '3',
        name: 'Nis',
        zipCode: '-1',
      };
    case 'lzbmia.joybird.com':
      return {
        id: '17',
        name: 'LZB Miami',
        zipCode: '-1',
      };
    case 'cm.joybird.com':
      return {
        id: '20',
        name: 'Costa Mesa, CA',
        zipCode: '92626',
      };
    case 'mv.joybird.com':
      return {
        id: '19',
        name: 'Mission Viejo, CA',
        zipCode: '92691',
      };
    case 'col.joybird.com':
      return {
        id: '21',
        name: 'Columbus, OH',
        zipCode: '43219',
      };
    case 'scot.joybird.com':
      return {
        id: '22',
        name: 'Scottsdale, AZ',
        zipCode: '85254',
      };
    case 'dal.joybird.com':
      return {
        id: '70',
        name: 'Dallas',
        zipCode: '75205',
      };
    case 'dp.joybird.com':
      return {
        id: '72',
        name: 'Deer Park, IL',
        zipCode: '60010',
      };
    case 'gld.joybird.com':
      return {
        id: '76',
        name: 'Glendale, AZ',
        zipCode: '85308',
      };

    case 'cos.joybird.com':
      return {
        id: '77',
        name: 'Colorado Springs, CO',
        zipCode: '80920',
      };

    case 'nov.joybird.com':
      return {
        id: '78',
        name: 'Novi, MI',
        zipCode: '48377',
      };

    case 'pas.joybird.com':
      return {
        id: '80',
        name: 'Pasadena, CA',
        zipCode: '91105',
      };
    default:
      return null;
  }
};

export default getStoreDetails;
